import React, { FC } from 'react';
import styled from 'styled-components';

interface IOptionScrollerProps {
    maxHeight?: string;
}

export const OptionScroller: FC<IOptionScrollerProps> = ({ children, maxHeight = '300px' }) => {
    return (
        <li>
            <ListUl maxHeight={maxHeight}>{children}</ListUl>
        </li>
    );
};

const ListUl = styled.ul<{ maxHeight: string }>`
    max-height: ${(props) => props.maxHeight};
    overflow-y: auto;
    padding: 0;
    margin: 0;
    list-style: none;
`;
